import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createApp, h } from 'vue';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import { createPinia } from 'pinia';
import { useSettingsStore } from './stores/settings';

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';

createInertiaApp({
    title: (title) => title ? `${title}` : 'Qorvin IT',
    resolve: (name) =>
        resolvePageComponent(
            `./Pages/${name}.vue`,
            import.meta.glob('./Pages/**/*.vue'),
        ),
    setup({ el, App, props, plugin }) {
        const pinia = createPinia();
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(pinia);
        
        // Load settings globally on app start (hydrated from shared props or window)
        const settingsStore = useSettingsStore(pinia);
        if (props.initialPage.props.siteSettings) {
            settingsStore.settings = props.initialPage.props.siteSettings;
        }
        
        return app.mount(el);
    },
    progress: {
        color: '#4B5563',
    },
});
